type ResponsiveValue = number | string | Record<string, number | string>

const personaAvatarBaseSx = {
  background:
    'var(--app-avatar-bg, linear-gradient(180deg, rgba(255, 255, 255, 0.86) 0%, rgba(246, 250, 249, 0.7) 100%))',
  color: 'var(--app-avatar-color, #32423E)',
  border: '1px solid var(--app-avatar-border, rgba(11, 214, 141, 0.18))',
  boxShadow:
    'var(--app-avatar-shadow, inset 0 0 0 1px rgba(255, 255, 255, 0.72), 0 1px 3px rgba(34, 47, 62, 0.035))',
  backdropFilter: 'var(--app-avatar-blur, blur(10px) saturate(135%))',
  WebkitBackdropFilter: 'var(--app-avatar-blur, blur(10px) saturate(135%))',
  fontWeight: 600,
}

export const getPersonaAvatarSx = (
  size: ResponsiveValue,
  fontSize?: ResponsiveValue
) => ({
  ...personaAvatarBaseSx,
  width: size,
  height: size,
  fontSize: fontSize ?? 12,
})

export const getAvatarSx = (
  size: ResponsiveValue,
  hasImage?: boolean,
  fontSize?: ResponsiveValue
) =>
  hasImage
    ? {
        width: size,
        height: size,
      }
    : getPersonaAvatarSx(size, fontSize)
